module.exports = __webpack_public_path__ + "img/East_Renfrewshire.29a1f5c2.png";